import React from 'react'
import { useTranslation } from 'react-i18next'
import { match } from 'ts-pattern'
import { MenuItemOptionFragment, MenuItemOptionType } from '@/generated/graphql'
import { OptionGuideText } from './index.styles'

const OptionGuidanceText: React.FC<{
  option: MenuItemOptionFragment
  quantity: number
}> = ({ option, quantity }) => {
  const { minQty, maxQty, qtyPerPerson, optionType } = option || {}
  const { t } = useTranslation()

  const text = match(optionType)
    .with(MenuItemOptionType.Ticks, () => {
      if (!minQty && maxQty) {
        return `${t('marketplace:chooseUpTo')} ${maxQty} ${maxQty > 1 ? t('marketplace:types') : t('marketplace:type')}`
      }
      if (minQty && minQty === maxQty) {
        return `${t('marketplace:youMustSelect')} ${minQty} ${minQty > 1 ? t('marketplace:types') : t('marketplace:type')}`
      }
      if (minQty && !maxQty) {
        return `${t('marketplace:youMustSelectAtLeast')} ${minQty} ${minQty > 1 ? t('marketplace:types') : t('marketplace:type')}`
      }
      if (minQty && maxQty) {
        return `${t('marketplace:chooseAtLeast')} ${minQty} - ${maxQty} ${t('marketplace:types')}`
      }
      return null
    })
    .with(MenuItemOptionType.Numbers, () => {
      if (qtyPerPerson) {
        return t('marketplace:selectXItems', { minQty: quantity * qtyPerPerson })
      }
      if (!minQty && maxQty) {
        return `${t('marketplace:chooseUpTo')} ${maxQty} ${maxQty > 1 ? t('marketplace:differentTypes') : t('marketplace:type')}`
      }
      if (minQty && minQty === maxQty) {
        return `${t('marketplace:choose')} ${minQty} ${minQty > 1 ? t('marketplace:differentTypes') : t('marketplace:type')}`
      }
      if (minQty && !maxQty) {
        return `${t('marketplace:chooseAtLeast')} ${minQty} ${minQty > 1 ? t('marketplace:differentTypes') : t('marketplace:type')}`
      }
      if (minQty && maxQty) {
        return `${t('marketplace:choose')} ${minQty} - ${maxQty} ${t('marketplace:differentTypes')}`
      }
      return null
    })
    .otherwise(() => null)

  return <OptionGuideText>{text}</OptionGuideText>
}

export default OptionGuidanceText
